import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Store } from '../store';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IPhotoBatch } from './user-photo-submissions/user-photo-submissions.component';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ImagesService {
    env = environment;

    pagination = {
        searchTerm: '',
        fileType: '',
        limit: 25,
        limits: [5, 10, 25, 50],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'docs.friendlyName',
        sorts: [
            { ID: 'docs.friendlyName ASC', name: 'Name A-Z' },
            { ID: 'docs.friendlyName DESC', name: 'Name Z-A' },
            { ID: 'docs.created ASC', name: 'Created Oldest' },
            { ID: 'docs.created DESC', name: 'Created Newest' },
        ],
    };

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private apiService: ApiService,
        private store: Store
    ) {}

    getPagination() {
        return this.pagination;
    }
    setPagination(field, value) {
        this.pagination[field] = value;
    }

    getTypes() {
        return this.http.get(this.env.apiPath + 'cms/images/types', this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    get(type, ownerId) {
        const user = this.store.selectForLocal('user');
        const dataToSend = {
            user,
            type,
            ownerId,
            pagination: this.pagination,
        };
        return this.http.post(this.env.apiPath + 'cms/images', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    delete(image) {
        return this.http.delete(this.env.apiPath + 'cms/images/' + image.id, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }
    move(image) {
        const dataToSend = {
            image,
        };
        return this.http.post(this.env.apiPath + 'cms/images/move', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    crop(image) {
        return this.http.post(this.env.apiPath + 'cms/images/crop', image, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    updateSortOrder(images) {
        const dataToSend = {
            images,
        };
        return this.http.post(this.env.apiPath + 'cms/images/sort', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getPhotoBatches(): Observable<IPhotoBatch> {
        return this.http
            .get(this.env.apiPath + 'customer-photos/photo-batches', this.apiService.getHttpOptions())
            .pipe(map((data) => (<any>data).data));
    }

    getPhotosFromBatch(batchId): Observable<any> {
        return this.http
            .get(this.env.apiPath + `customer-photos/batch-photos/${batchId}`, this.apiService.getHttpOptions())
            .pipe(map((data) => (<any>data).data));
    }

    setWinner(batchId, photoId) {
        const dataToSend = {
            batchId,
            photoId,
        };
        return this.http
            .post(this.env.apiPath + `customer-photos/set-winner`, dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data) => (<any>data).data));
    }
}
